import { useCallback } from 'react';

import { ROUTES, ROUTE_PARAMS } from 'src/routes';
import * as events from 'src/lib/events';
import { formatProjectCreateRoute, formatProjectRoute, formatRoute } from 'src/lib/routing';
import { PROJECT_TYPE } from 'src/data/project';
import { useHistory } from 'src/services/useHistory';
import { CHANNEL_TO_GENERATION_TOOL_MAPPER } from 'src/data/performance';
import { PAGES, useTrackingEvent } from 'src/services';

export const useHandlers = ({ channel, onClose, projectId, variationId, variation }) => {
  const history = useHistory();
  const trackingEvent = useTrackingEvent();

  const handleImproveClick = useCallback(() => {
    trackingEvent(events.DATA_EXTRACTION_NAVIGATION_POPUP.analyticsClick, {
      page: PAGES.copyAnalytics,
      channel,
    });
    onClose();
    history.push(
      formatRoute(ROUTES.ANALYTICS, {
        [ROUTE_PARAMS.channel]: channel,
      })
    );
  }, [trackingEvent, onClose, channel, history]);

  const handleBenchmarkClick = useCallback(async () => {
    trackingEvent(events.DATA_EXTRACTION_NAVIGATION_POPUP.benchmarkClick, {
      page: PAGES.copyAnalytics,
      channel,
    });
    if (projectId && variationId) {
      history.push(formatProjectRoute(projectId, { [ROUTE_PARAMS.variationId]: variationId }));
      onClose();
    } else {
      let link;
      if (variation?.projectId) {
        link = formatProjectRoute(variation.projectId, {
          [ROUTE_PARAMS.variationId]: variation.id,
        });
      } else {
        link = formatProjectCreateRoute(PROJECT_TYPE.document, {
          [ROUTE_PARAMS.generationTool]: CHANNEL_TO_GENERATION_TOOL_MAPPER[channel],
        });
      }
      history.push(link);
      onClose();
    }
  }, [trackingEvent, onClose, channel, projectId, variationId, history, variation]);

  return {
    handleImproveClick,
    handleBenchmarkClick,
  };
};
